import { supabase } from "./supabaseClient";

/**
 * Store quiz results in Supabase
 * @param {Object} quizResults - The quiz results to store
 */
export const storeQuizResults = async (quizResults) => {
	try {
		const { data, error } = await supabase
			.from("quiz_results")
			.insert([quizResults]);

		if (error) throw error;
		console.log("Quiz results saved successfully:", data);
	} catch (error) {
		console.error("Error saving quiz results:", error);
	}
};

/**
 * Fetch quiz results for a specific player in a quiz
 * @param {Object} params - Object containing quizId and playerId
 * @param {string} params.quizId - The quiz ID
 * @param {string} params.playerId - The player ID
 * @returns {Object} - The quiz results data or an error
 */
export const fetchQuizResults = async ({ quizId, playerId }) => {
	try {
		const { data, error } = await supabase
			.from("quiz_results")
			.select("*")
			.eq("player_id", playerId)
			.eq("quiz_id", quizId);

		if (error && error.code !== "PGRST116") {
			console.error("Error fetching quiz results:", error);
			throw error;
		}

		if (data && data.length > 0) {
			return { data: data[0], error };
		}

		return { data, error };
	} catch (error) {
		console.error("Error fetching quiz results:", error);
		return { data: null, error };
	}
};

export const fetchScoresForQuizIds = async (quizIds, pageSize = 1000) => {
	try {
		let allResults = [];
		let from = 0;
		let hasMore = true;

		while (hasMore) {
			const { data, error } = await supabase
				.from("quiz_results")
				.select("score, player_id, quiz_id")
				.in("quiz_id", quizIds)
				.range(from, from + pageSize - 1);

			if (error && error.code !== "PGRST116") {
				console.error("Error fetching quiz results:", error);
				throw error;
			}

			if (data?.length) {
				allResults = allResults.concat(data);
				from += pageSize;
				hasMore = data.length === pageSize;
			} else {
				hasMore = false;
			}
		}

		return { data: allResults, error: null };
	} catch (error) {
		console.error("Error fetching quiz results:", error);
		return { data: null, error };
	}
};
